import React from 'react';

import { Navigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { RouteFallback } from './RouteFallback';

/**
 * AdminRoute component
 * Intent: Ensure only users with admin profile can access protected admin pages
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <RouteFallback />;
  }

  // Check if user is logged in and has admin profile
  if (!user || !user.profiles.includes('admin')) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
